import "./App.css";
import Desktop from "./components/Desktop";
import useIdleTimer from "./components/useIdleTimer";
import ScreenSaver from "./components/ScreenSaver";
import Bsod from "./components/BSOD";
import PowerOn from "./components/PowerOn";

import { useEffect, useState } from "react";

function App() {
  const isIdle = useIdleTimer(30000); // idle timeout

  const [bsodActive, setBsodActive] = useState(false);
  const [bsodTriggered, setBsodTriggered] = useState(false);
  const [isPoweredOn, setIsPoweredOn] = useState(false);

  useEffect(() => {
    let buffer = "";
    const laucnh_code = "bsod";
    const handleKeyDown = (e) => {
      buffer += e.key;

      // Keep only the last 4 characters
      if (buffer.length > laucnh_code.length)
        buffer = buffer.slice(laucnh_code.length);

      if (buffer === laucnh_code) {
        setBsodActive(true);
        setBsodTriggered(true);
        buffer = "";
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    // Random chance (5%) that BSOD will happen sometime during runtime
    const probability = 0.05;
    if (Math.random() < probability && !bsodTriggered) {
      // Pick a random delay between 1 and 2 minutes
      const randomDelay = (Math.floor(Math.random() * 5) + 1) * 60 * 1000; // between 1 and 5 minutes converted to seconds then milliseconds

      console.log("BSOD will fire in ", randomDelay / (1000 * 60), "minutes");

      const timer = setTimeout(() => {
        setBsodActive(true);
        setBsodTriggered(true);
      }, randomDelay);

      return () => clearTimeout(timer);
    }
  }, [bsodTriggered]);

  if (bsodActive) return <Bsod />;

  return (
    <>
      {!isPoweredOn ? (
        <PowerOn clicked={() => setIsPoweredOn(true)} />
      ) : (
        <>
          {isIdle && <ScreenSaver />}
          <Desktop />
        </>
      )}
    </>
  );
}

export default App;
